import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { FormControl, FormHelperText, InputLabel, MenuItem, IconButton, Select } from '@material-ui/core'
import { Check } from '@material-ui/icons'

const styles = (theme: CentricTheme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  button: {
    display: 'block',
    marginTop: theme.spacing() * 2
  },
  formControl: {
    margin: theme.spacing(),
    minWidth: 122,
    maxWidth: 280
  },
  iconButton: {
    padding: `0 12px 0`
  },
  icon: {
    width: 24,
    height: 24
  },
  selectText: {
    fontSize: 16
  },
  selectOption: {
    fontSize: 16,
  }
})

interface MyProps extends StyledProps {
  /** String for the name of the field */
  name?: string,
  /** String for the value of the component */
  value?: any,
  /** Object for the select's options */
  options: Array<any>
  /** String for the select's label */
  label?: string,
  /** Function to be called when the component changes */
  onChange: (e) => void
  /** Boolean indicating whether the field is errored or not */
  error?: boolean
  /** String for field's error text when errored */
  errorText?: string,
  /** Boolean indicating whether the button should render as disabled */
  disabled: boolean
  /** Object key for menu item label */
  itemLabel: string,
  /** Object key for menu item value */
  itemValue: string,
  /** Value to show Check Icon on selection */
  checkIcon: boolean
  /** Max width for the select component */
  width?: number,
  /** Tooltip text to be shown on hover */
  tooltip?: string

  SelectDisplayProps?: any

  itemLeftImage?: string
}

export class SelectInputComponent extends React.Component<MyProps> {
  static defaultProps = {
    disabled:  false,
    onChange:  () => {},
    itemLabel: 'name',
    itemValue: 'value',
    checkIcon: false
  }

  render() {
    const {classes, className, name, value, label, options, itemLabel, itemValue, onChange, error, errorText, disabled, checkIcon, width, tooltip, itemLeftImage, ...otherProps} = this.props

    return (
      <div className={classNames(classes.container, className)}>
        <FormControl className={classes.formControl} error={error} aria-describedby={`${name}-error-text`}>
          {label && <InputLabel htmlFor={`${name}-select`}>{label}</InputLabel>}
          <Select value={value} onChange={onChange}
                  inputProps={{
                    name: name,
                    id:   `${name}-select`
                  }}
                  // classes={classes}
                  className={classes.selectText}
                  error={error && !disabled}
                  disabled={disabled}
                  style={width ? {width: `${width}px`} : undefined}
                  {...otherProps}
                  title={tooltip || value}
          >
            {options.length
             ? options.map((option) => <MenuItem disabled={option['disabled'] || false} className={classes.selectOption} key={option[itemLabel]} value={option[itemValue]}>
                {checkIcon && <span className={classes.iconButton}><IconButton className={classes.icon}>
                {value === option[itemValue] ? <Check/> : null}
              </IconButton></span>
                }
                {option[itemLeftImage] ? option[itemLeftImage] : null }
                {option[itemLabel] || 'NA'}
              </MenuItem>)
             : <MenuItem className={classes.selectOption} value=''>
               <em>None</em>
             </MenuItem>}
          </Select>
          {error && !disabled ? <FormHelperText id={`${name}-error-text`}>{errorText}</FormHelperText> : null}
        </FormControl>
      </div>
    )
  }
}

@(withStyles as any)(styles)
export class SelectInput extends SelectInputComponent {}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/SelectInput.tsx